import { Helmet } from '@dr.pogodin/react-helmet';

type THelmetWithTitleAndDescription = {
  title: string;
  description?: string;
  children?: any;
};

export function HelmetWithTitleAndDescription(props: THelmetWithTitleAndDescription) {
  const { description, title, children } = props;

  return (
    <Helmet>
      <title>{title}</title>
      <meta property="og:title" content={title} />
      {(description?.length ?? 0) > 0 && <meta name="description" content={description} />}
      {(description?.length ?? 0) > 0 && <meta property="og:description" content={description} />}
      {children}
    </Helmet>
  );
}
